var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('div',[_c('VSlider',{attrs:{"title":_vm.$t('related_drugs.other_products'),"source":"drugs/REQUEST_DRUGS_BOUGHT_WITH","payload":_vm.sliderPayload,"type":"compact"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }